import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import AdvancedSelectFormik from "app/pages/.shared/form/AdvancedSelectFormik/AdvancedSelectFormik";
import { memo, useContext } from "react";
import AppGlobalsContext from "app/AppGlobalsContext";
import SmartDPInputSidePanelContent from "app/pages/SmartDP/Search/SDPSearchForm/SmartDPInputSidePanelContent";
import FloatingAdvancedSelectFormik from "app/pages/.shared/form/FloatingAdvancedSelectFormik/FloatingAdvancedSelectFormik";

const SmartDPSearchInput = props => {
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	// eslint-disable-next-line no-nested-ternary
	return isMobile ? (
		<SmartDPInputSidePanelContent {...props} />
	) : props?.isFloating ? (
		<FloatingAdvancedSelectFormik {...props} />
	) : (
		<AdvancedSelectFormik {...props} />
	);
};
export default memo(SmartDPSearchInput);
